/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { EditCommentRequest } from '../../models/edit-comment-request';

export interface CommentsCommentIdPut$Plain$Params {
  commentId: string;
      body?: EditCommentRequest
}

export function commentsCommentIdPut$Plain(http: HttpClient, rootUrl: string, params: CommentsCommentIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
  const rb = new RequestBuilder(rootUrl, commentsCommentIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('commentId', params.commentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommentDto>;
    })
  );
}

commentsCommentIdPut$Plain.PATH = '/comments/{commentId}';
